export const DEV_BUILD_ID = 'dev';
export function parseVersionPayload(data) {
    if (!data || typeof data !== 'object')
        return null;
    const buildId = data.buildId;
    if (typeof buildId !== 'string')
        return null;
    const trimmed = buildId.trim();
    return trimmed.length > 0 ? trimmed : null;
}
export function hasNewAppVersion(currentBuildId, remoteBuildId) {
    if (!currentBuildId || currentBuildId === DEV_BUILD_ID || !remoteBuildId) {
        return false;
    }
    return currentBuildId !== remoteBuildId;
}
export async function hardReloadApp() {
    try {
        await fetch('/index.html', { cache: 'reload', credentials: 'same-origin' });
    }
    catch {
        /* reload even if the prefetch fails */
    }
    try {
        if ('caches' in window) {
            const keys = await window.caches.keys();
            await Promise.all(keys.map(key => window.caches.delete(key)));
        }
    }
    catch {
        /* Cache Storage may be unavailable */
    }
    window.location.reload();
}
